import BigNumber from 'bignumber.js'
import { getCakeVaultContract } from 'utils/contractHelpers'

const cakeVaultContract = getCakeVaultContract()

const fetchVaultUser = async (account: string) => {
  try {
    const user = await cakeVaultContract.userInfo(account)
    const sharePrice = await cakeVaultContract.getPricePerFullShare()

    return {
      isLoading: false,
      userShares: new BigNumber(user.shares.toString()).toJSON(),
      lastDepositedTime: user.lastDepositedTime.toString(),
      lastUserActionTime: user.lastUserActionTime.toString(),
      cakeAtLastUserAction: new BigNumber(user.cakeAtLastUserAction.toString()).toJSON(),
      pricePerFullShare: new BigNumber(sharePrice.toString()).toJSON(),
    }
  } catch (error) {
    return {
      isLoading: true,
      userShares: null,
      cakeAtLastUserAction: null,
      lastDepositedTime: null,
      lastUserActionTime: null,
      pricePerFullShare: null,
    }
  }
}

export default fetchVaultUser
